"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var TagEntity_1 = __importDefault(require("./Entity/TagEntity"));
var Tag = /** @class */ (function () {
    function Tag(session) {
        this.tagEntity = new TagEntity_1.default(session);
    }
    Tag.prototype.getAll = function () {
        return this.tagEntity.service.getAll();
    };
    Tag.prototype.create = function (tag) {
        return this.tagEntity.service.create(tag);
    };
    Tag.prototype.update = function (id, tag) {
        return this.tagEntity.service.update(id, tag);
    };
    Tag.prototype.delete = function (id) {
        return this.tagEntity.service.delete(id);
    };
    return Tag;
}());
exports.default = Tag;
//# sourceMappingURL=Tag.js.map